import { mainApi } from '../../../../api/mainApi';
import { middlewareApi } from '../../../middleware/middlewareApi';

import { EducationLevelsResponse } from '../../education-levels/interfaces/educationLevels.interfaces';

export const educationLevelCareersTags = middlewareApi.enhanceEndpoints({
  addTagTypes: ['EducationLevelCareer'],
});

// Define a service using a base URL and expected endpoints
export const educationLevelCareersApi = educationLevelCareersTags.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * @GET career group
     */
    getCareerGroup: builder.query<
      EducationLevelsResponse,
      { profileId: number; page: number; perPage: number; search: string; groupId: string }
    >({
      queryFn: async ({ profileId, page, search, perPage, groupId }) => {
        try {
          const { data } = await mainApi.get<EducationLevelsResponse>(
            `/group-areas/${groupId}/education-levels`,
            {
              params: {
                user_profile_id: profileId,
                page,
                size: perPage,
                type_sort: 'desc',
                search,
              },
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetCareerGroupQuery } = educationLevelCareersApi;
